import "./App.css";
import Header from "./components/header";
import Home from "./pages/home";

function App() {
    return (
        <div className="App">
            <Header />
            <Home />
        </div>
    );
}

export default App;
